export const EditorInit =  {
    branding: false,
    height: 200,
    menubar: false,
    relative_urls : false,
    convert_urls: false,
    plugins: 'link image media lists code',
    toolbar: 'blocks | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | outdent indent numlist bullist | removeformat | code',
    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
}